<template>

    <div>

        <!-- page-heading -->
        <page-heading pageTitle="PIM-PRODUCTS-HEADER"></page-heading>


        <div class="columns">

            <div class="col-main">

                <pim-products ref="pimProducts" :showPagination="true" :allMarked="allMarked" @selectedRows="onSelectRows" @dataLoaded="onTableDataLoaded">
                </pim-products>

            </div>

            <div class="col-aside">

                <affix :offset="50">

                    <template v-if="tableDataLoaded">

                        <template v-if="userRole == 'Apotheke' || pharmacySelected != NULL">

                            <custom-button icon="icon-ak-hinzufuegen" name="PIM-BTN-NEW_PRODUCT" type="blue"
                                @click.native="newProduct()"></custom-button>
                            <custom-button type="dark" icon="fa fa-cloud-upload" name="PIM-BTN-SORTIMENT_UPLOAD"
                                @click.native="uploadSortimentData()"></custom-button>

                        </template>

                        <custom-button type="dark" name="PIM-BTN-BATCH" :is-disabled="this.markedRows.length == 0"
                            @click.native="productsBatch"></custom-button>
                        <custom-button type="dark" name="PIM-BTN-MAKE_VARIABLE"
                            :is-disabled="this.markedRows.length < 2" @click.native="makeVariable"></custom-button>
                        <br />
                        <br />

                        <template v-if="userRole != 'Apotheke'">

                            <export-button
                                exportUrl="pimProduct/exportShopProducts?output=xlsx&link=1&filename=apopoint-produkte"
                                btnTitle="PIM_BTN_EXPORT" modalTitle="MODAL_HEADER-PIM_EXPORT"></export-button>

                            <br />
                            <!--
                    <custom-button type="dark" name="PIM-BTN-IMAGE_UPLOAD" @click.native="massImageUpload"></custom-button>
                    -->

                            <!--
                    <template v-if="['matthias', 'maksym', 'andreas'].indexOf(this.activeUser.username) > -1">
                      <custom-button type="dark" name="PIM-BTN-IMAGE_UPLOAD" @click.native="openUploadModal"></custom-button>
                    </template>

<template v-else>
                      <custom-button type="dark" name="PIM-BTN-IMAGE_UPLOAD" @click.native="massImageUpload"></custom-button>
                    </template>
-->


                            <!--
                    <template v-if="['christopher'].indexOf(this.activeUser.username) == -1">
                      <custom-button type="dark" name="PIM-BTN-IMAGE_UPLOAD" @click.native="openUploadModal"></custom-button>
                    </template>

                    <template v-else>
                      <custom-button type="dark" name="PIM-BTN-IMAGE_UPLOAD" @click.native="massImageUpload"></custom-button>
                    </template>
                  -->

                            <custom-button type="dark" name="PIM-BTN-IMAGE_UPLOAD"
                                @click.native="openUploadModal"></custom-button>

                        </template>

                        <template v-if="userRole == 'Administrator'">

                            <export-button exportUrl="apopoint/exportSearchLog?output=xlsx&link=1"
                                btnTitle="PIM-PTN-DOWNLOAD-SEARCH_PROTOCOL"
                                modalTitle="MODAL_HEADER-DOWNLOAD-SEARCH_PROTOCOL"
                                :title="$t('MODAL_HEADER-DOWNLOAD-SEARCH_PROTOCOL')"></export-button>

                        </template>

                    </template>

                </affix>

            </div>

        </div>

        <!-- MODAL -->
        <modal :title="modal.title" cancel-text="Abbrechen" ok-text="Speichern" transition="fadeDown"
            :show-cancel="false" :show-ok="false" :is-show="showModal" :backdrop-closable="false" :show-footer="true"
            @close="closeModal" :class="['vcenter', modal.class]">

            <div v-if="modal.isLoading"
                style="height: 500px; display: flex; align-items: center; justify-content: center;">

                <loading-indicator></loading-indicator>

            </div>

            <template v-else>

                <!-- PRODUCT BATCHING -->
                <template v-if="modal.type == 'products-batch'">

                    <tabs>

                        <tab-item label="Stammdaten">

                            <form-input inputType="text" :placeholder="placeholder" label="PIM-BATCH-NAME"
                                v-model="batchObj.name" is-horizontal="true"></form-input>

                            <div class="control is-horizontal">

                                <div class="control-label">
                                    <label-name labelKey="PIM-BATCH-DESCRIPTION"></label-name>
                                </div>
                                <div class="control froalaRTE froalaPlain">
                                    <froala id="froala" ref="froala" :tag="'textarea'" :config="froalaConfig"
                                        v-model="batchObj.description"></froala>
                                </div>

                            </div>

                            <form-input inputType="text" :placeholder="placeholder" label="PIM-BATCH-BRAND"
                                v-model="batchObj.manufacturerName" is-horizontal="true"></form-input>
                            <form-input inputType="text" :placeholder="placeholder" label="PIM-BATCH-FLAVOR"
                                v-model="batchObj.flavor" is-horizontal="true"></form-input>
                            <form-input inputType="text" :placeholder="placeholder" label="PIM-BATCH-COLOR"
                                v-model="batchObj.color" is-horizontal="true"></form-input>

                        </tab-item>

                        <tab-item label="Medien">

                            <div class="control is-horizontal">

                                <div class="control-label">
                                    <label-name labelKey="PIM-BATCH-UPLOAD_FILES"></label-name>
                                </div>

                                <div class="control">

                                    <vue-dropzone 
                                        ref="vueDropzonePimBatch" 
                                        id="vueDropzonePimBatch"
                                        url="fileProcessing/upload?preset=pimProductBatch" 
                                        :thumbnailWidth="100"
                                        :thumbnailHeight="100" 
                                        max-files="1" 
                                        acceptedFiles=".jpg,.jpeg,.png,.gif,.zip"
                                        dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Produktbild hochladen"
                                        v-on:vdropzone-removed-file="dzRemoveFile"
                                        v-on:vdropzone-success="dzSuccess">
                                    </vue-dropzone>
                                </div>

                            </div>


                            <template v-if="uploadedFiles != null && uploadedFiles.length > 0">

                                <div class="control is-horizontal">
                                    <div class="control-label">
                                        <label-name labelKey="PIM-BATCH-IS_PRIMARY_PICTURE"></label-name>
                                    </div>
                                    <div class="control">
                                        <b-switch v-model.sync="uploadedFiles[0].isActive" type="primary"
                                            size="small"></b-switch>
                                    </div>
                                </div>

                            </template>

                        </tab-item>

                        <tab-item label="Webshop">

                            <!-- Category -->
                            <div class="control">
                                <div class="control-label">
                                    <label-name labelKey="PIM-BATCH-CATEGORY"></label-name>
                                </div>
                                <div class="control" style="white-space: normal;">
                                    <treeselect v-model="batchObj.category" placeholder="Kategorie auswählen"
                                        :multiple="false" :options="categories" :normalizer="normalizer">
                                    </treeselect>
                                </div>
                            </div>


                            <template v-if="userRole == 'Apotheke' || pharmacySelected != NULL">

                                <!-- unitPrice -->
                                <form-input inputType="text" :is-horizontal="false" :label="'PIM-PRODUCT-UNIT_PRICE'"
                                    v-model="batchObj.unitPrice" :placeholder="placeholder">
                                </form-input>

                                <!-- vatPercent -->
                                <form-input inputType="text" :label="'PIM-PRODUCT-VAT_PERCENT'"
                                    v-model="batchObj.vatPercent" :isPointToComma="true" :is-horizontal="false"
                                    :placeholder="placeholder">
                                </form-input>

                                <!-- packagingSize -->
                                <form-input inputType="text" label="PIM-PRODUCT-PACKAGING_SIZE-PIM"
                                    v-model="batchObj.packagingSizes.pim" :isPointToComma="true" v-bind:key="key"
                                    :is-horizontal="false" :placeholder="placeholder">
                                </form-input>

                                <!-- dosageForm -->
                                <form-input inputType="select" :showLabelInOptions="false"
                                    :label="'PIM-PRODUCT-DOSAGE_FORM'" :placeholder="placeholder"
                                    :selectIsSearchable="true" v-model="dosageFormWrapper"
                                    :selectOptions="dosageFormsOptions" :is-horizontal="false">
                                </form-input>

                                <!-- amountInStock -->
                                <form-input inputType="text" :label="'PIM-PRODUCT-AMOUNT_IN_STOCK_SITE'"
                                    v-model="batchObj.erp.amountInStock" :placeholder="placeholder"
                                    :is-horizontal="false"></form-input>

                            </template>

                            <!-- Tags -->
                            <form-input inputType="text" :placeholder="placeholder" label="PIM-BATCH-TAGS"
                                v-model="batchObj.tags" :is-horizontal="false"></form-input>

                            <!-- Ranking -->
                            <form-input inputType="text" :placeholder="placeholder" label="PIM-BATCH-RANKING"
                                v-model="batchObj.score" :is-horizontal="false"></form-input>

                            <!-- Visibility -->
                            <form-input inputType="select" label="PIM-BATCH-VISIBILITY"
                                v-model="batchObj.apopointVisibility" :is-horizontal="false"
                                :selectOptions="apopointProductVisibility"></form-input>

                        </tab-item>

                    </tabs>

                    <div slot="footer">

                        <span :class="['button', { 'is-disabled': modal.isSaving || modal.isLoading }]"
                            @click="closeModal">abbrechen</span>
                        <span
                            :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': modal.isLoading }]"
                            @click="batchIt">weiter</span>

                    </div>

                </template>


                <!-- UPLOAD SELECTOR / SWITCHER -->
                <template v-else-if="modal.type == 'upload-switcher'">

                    <div style="display: flex; gap: 10px;align-items: center; justify-content: center;">
                        <custom-button type="dark" name="PIM-BTN-SINGULAR_IMAGES_UPLOAD"
                            @click.native="massImageUpload"></custom-button>
                        <custom-button type="dark" name="PIM-BTN-ZIP_UPLOAD"
                            @click.native="zipFileUpload"></custom-button>
                    </div>


                    <div slot="footer">
                        <span class="button" @click="closeModal">abbrechen</span>
                    </div>


                </template>

                <!-- MULTI IMAGE UPLOAD -->
                <template v-else-if="modal.type == 'multi-upload-files'">

                    <!-- url="fileProcessing/upload?preset=pimProductBatch" -->
                    <vue-dropzone url="fileProcessing/upload?preset=pimProductBatch&createAssets=1"
                        ref="vueDropzonePimMulti" id="vueDropzonePimMulti" :autoProcessQueue=false :thumbnailWidth="100"
                        :thumbnailHeight="100" :uploadMultiple="true" acceptedFiles=".jpg,.jpeg,.png,.gif,.zip"
                        dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Produktbild hochladen"
                        v-on:vdropzone-removed-file="dzRemoveFile" v-on:vdropzone-files-added="dzFilesAddedMulti"
                        v-on:vdropzone-success-multiple="dzSuccessMulti" :dzClass="{ 'hidden': uploadProcedere > 0 }"
                        style="height: 100%;">
                    </vue-dropzone>

                    <!-- uploadProcedere step 1 -->
                    <div class="loadingOverlay" v-if="uploadProcedere == 1">
                        <loading-indicator></loading-indicator>
                    </div>

                    <!-- uploadProcedere step 2 -->
                    <template v-else-if="uploadProcedere == 2">

                        <!-- accepted files -->
                        <div class="filesContainer" v-if="acceptedFiles.length > 0">

                            <div class="fileBox" v-for="file in acceptedFiles" :key="file.id">

                                <div class="name">{{ file.name }}</div>

                                <div class="images">

                                    <div v-for="asset in file.assets" :key="asset.fileName"
                                        :class="['image', { 'is-active': asset.isActive }]"
                                        @click="setAssetActive(file, asset)">

                                        <span><strong>neu</strong></span>
                                        <!-- <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="asset.url"></div> -->
                                        <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="asset.url">
                                        </div>
                                        <!-- <div class="imgWrapper" :style="{ backgroundImage: 'url(' + asset.url + ')' }"></div> -->
                                    </div>

                                    <div v-if="!file.folder && file.image"
                                        :class="['image', { 'is-active': file.isActive }]"
                                        @click="setAssetActive(file)">
                                        <span>aktuell</span>
                                        <div class="imgWrapper lazy-img-fadein"
                                            v-lazy:background-image="file.special ? file.image : $config.assets + file.image">
                                        </div>
                                    </div>

                                    <div v-else class="image is-disabled">
                                        <div class="imgWrapper"></div>
                                    </div>

                                </div>


                            </div>

                        </div>

                        <!-- rejected files -->
                        <div class="rejectedFiles" v-if="rejectedFiles.length > 0">

                            <!-- <lang labelKey=""></lang> -->
                            <div style="margin-bottom: 5px;">
                                <strong>Achtung:</strong> Für diese {{ rejectedFiles.length }} Dateien konnte kein
                                passendes Produkt gefunden werden:
                            </div>

                            <div class="filesContainer">
                                <div v-for="file in rejectedFiles" class="fileBox">
                                    <span class="name">{{ file.name }}</span>
                                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="file.url"></div>
                                </div>
                            </div>

                        </div>

                    </template>

                    <!-- uploadProcedere step 4 (PROGRESS) -->
                    <template v-else-if="uploadProcedere == 4">
                        
                        <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.message }}</div>
                        <progress-bar :percent="(progressStatus.progress * 100)" :striped="false" :animated="false"
                            size="large"></progress-bar>

                    </template>

                    <!-- uploadProcedere step 5 (FIN) -->
                    <template v-else-if="uploadProcedere == 5">

                        <div>

                            <alert type="success" :closable="false" v-if="acceptedFiles.length > 0">
                                {{ acceptedFilesTotal }}
                                <template v-if="acceptedFilesTotal > 1">
                                    Bilder wurden
                                </template>
                                <template v-else>
                                    Bild wurde
                                </template>
                                erfolgreich hochgeladen
                            </alert>

                            <alert type="warning" :closable="false" v-if="rejectedFiles.length > 0"
                                class="customWarning">

                                {{ rejectedFiles.length }}
                                <template v-if="rejectedFiles.length > 1">
                                    Bilder konnten
                                </template>
                                <template v-else>
                                    Bild konnte
                                </template>
                                nicht hochgeladen werden

                            </alert>

                        </div>

                        <!--
                        <div class="notification is-success" v-if="acceptedFiles.length > 0">

                            {{ acceptedFiles.length }}
                            <template v-if="acceptedFiles.length > 1">
                                Bilder wurden
                            </template>
                            <template v-else>
                                Bild wurde
                            </template>
                            erfolgreich hochgeladen

                        </div>

                        <div class="notification has-icon" v-if="rejectedFiles.length > 0">

                            {{ rejectedFiles.length }}
                            <template v-if="rejectedFiles.length > 1">
                                Bilder konnten
                            </template>
                            <template v-else>
                                Bild konnte
                            </template>
                            nicht hochgeladen werden
                        </div>

                        -->

                    </template>



                    <div slot="footer">

                        <template v-if="uploadProcedere < 5">
                            <span :class="['button', { 'is-disabled': modal.isSaving || modal.isLoading }]"
                                @click="closeModal">abbrechen</span>
                            <span
                                :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': modal.isLoading || acceptedFiles.length == 0 }]"
                                @click="uploadMultiFilesConfirmation">weiter</span>
                        </template>

                        <template v-else>

                            <span class="button" @click="closeModal">schließen</span>

                        </template>

                    </div>

                </template>

                <!-- ZIP UPLOAD -->
                <template v-else-if="modal.type == 'upload-zip'">

                    <vue-dropzone ref="vueDropzone" id="vueDropzone" url="pimProduct/assignAssets?zip=true"
                        :maxFiles="1" acceptedFiles=".zip" maxFilesize="2048" timeout="0"
                        dictDefaultMessage="<i class='fa fa-cloud-upload'></i>ZIP Datei"
                        v-on:vdropzone-files-added="dzFilesAddedZip" v-on:vdropzone-success="dzSuccessZip"
                        v-on:vdropzone-complete="dzCompleteZip" dzClass="default dzSingle">

                    </vue-dropzone>


                    <div slot="footer">

                        <span class="button" @click="closeModal">schließen</span>

                    </div>


                </template>


                <!-- SORTIMENTS UPLOADS -->
                <template v-else-if="modal.type == 'sortimentUpload'">

                    <div class="sortimentTypeButtons">

                        <div v-for="s in sortimentUploadTypes" @click="sortimentUploadType = s"
                            :class="{ 'is-active': sortimentUploadType == s }">
                            <lang :labelKey="'PIM-SORTIMENT_UPLOAD-FILTER-' + s"></lang>
                        </div>

                    </div>

                    <p class="sortimentTypeHint">
                        <strong>Info:</lang></strong>
                        <lang :labelKey="'PIM-SORTIMENT_UPLOAD-FILTER-HINT-' + sortimentUploadType"></lang>
                        <!-- <lang labelKey="PIM-SORTIMENT_UPLOAD-FILTER-HINT"> -->
                    </p>


                    <vue-dropzone style="margin-bottom: 25px;" ref="vueDropzone" id="vueDropzone"
                        url="fileProcessing/upload?preset=sitePimProducts" :maxFiles="1"
                        :formDataAppend="[{ site: pharmacySelected.id, format: sortimentUploadType }]"
                        acceptedFiles=".xls,.xlsx,.csv"
                        dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Sortimentsdatei"
                        v-on:vdropzone-success="dzSuccessSortiment" dzClass="default dzSingle">
                    </vue-dropzone>

                </template>

                <template v-else-if="modal.type == 'sortimentUploadProgress'">

                    <template v-if="progressStatus == null">

                        <loading-indicator-small></loading-indicator-small>

                    </template>

                    <template v-else>

                        <template v-if="progressStatus.status != 'Finished'">

                            <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                            <progress-bar :percent="progressStatus.progress" :striped="false" :animated="false"
                                size="large"></progress-bar>

                        </template>

                        <template v-else>

                            <div class="has-text-centered">Datei erfolgreich hochgeladen</div>

                            <div slot="footer">

                                <span class="button" @click="closeModal">schließen</span>

                            </div>

                        </template>

                    </template>

                </template>


            </template>

        </modal>


        <!-- CONFIRMATION MODAL -->
        <modal title="Bildupload" @close="closeModal" cancel-text="Abbrechen" :is-show="showModalConfirmation"
            :backdrop-closable="false" :show-footer="true" :show-cancel="true" width=640 class="modalConfirmation">

            <p>
                <lang labelKey="FILE_UPLOAD_BEHAVIOUR-INFO_TEXT"></lang>
            </p>


            <radio-group v-model="fileUploadBehaviourType" class="uploadBehaviourTypeSelection">
                <radio val="add"><strong>Hinzufügen</strong><br>
                    <lang labelKey="FILE_UPLOAD_BEHAVIOUR-ADD"></lang>
                </radio><br>
                <radio val="replace"><strong>Ersetzen</strong><br>
                    <lang labelKey="FILE_UPLOAD_BEHAVIOUR-REPLACE"></lang>
                </radio><br>
                <radio val="archive"><strong>Archivieren</strong><br>
                    <lang labelKey="FILE_UPLOAD_BEHAVIOUR-ARCHIVE"></lang>
                </radio><br>
            </radio-group>

            <div slot="footer">
                <!--
                <span class="button" @click="uploadMultiFiles(true)">Ersetzen</span>
                <span class="button is-primary" @click="uploadMultiFiles(false)">Hinzufügen</span>
                -->
                <span class="button" @click="showModalConfirmation = false">abbrechen</span>
                <span :class="['button is-primary', { 'is-loading': modal.isSaving }]"
                    @click="uploadMultiFiles()">weiter</span>
            </div>

        </modal>


    </div>


</template>




<script>
import Vue from 'vue';
import exportButton from '../utils/exportButton_v2';
import vue2Dropzone from '../utils/dropzoneWrapper'

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)

// import the component
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import pimProducts from './incl-pimProducts';

export default {

    name: 'pimProductsOverview',

    components: {
        exportButton,
        vueDropzone: vue2Dropzone,
        pimProducts,
        Treeselect
    },

    data() {

        var self = this;

        return {

            tableDataLoaded: false,
            allMarked: false,
            markedRows: [],

            placeholder: "keine Änderung",
            batchObj: {},

            categories: null,
            dosageForms: null,
            uploadedFiles: [],

            uploadProcedere: 0,
            multiUploadReplaceFiles: false,

            files: {
                accepted: [],
                rejected: [],
            },

            modal: {
                isSaving: false,
                isLoading: false,
                title: '',
                type: null,
                class: '',
            },

            refreshIntervalId: null,
            progressStatus: null,
            sortimentUploadType: 'default',

            froalaConfig: {
                key: '',
                linkAlwaysBlank: true,
                toolbarButtons: ["bold", "italic", "underline", "|", "paragraphFormat", "|", "insertLink", "|", "insertTable", "|", "clearFormatting"],
                wordPasteModal: false,
                pastePlain: true,
                heightMin: 300,
                heightMax: 1024,
                quickInsertTags: null,
                quickInsertButtons: false,
                language: 'de',
                charCounterCount: false,
            },

            showModal: false,
            showModalConfirmation: false,
            isZipUploading: false,
            zipUploadingFolder: null,
            fileUploadBehaviourType: "add",

        }

    },

    computed: {

        dosageFormsOptions() {
            let arr = [];

            for (let key in this.dosageForms) {
                arr.push({
                    id: key,
                    name: this.dosageForms[key]
                });
            }

            return arr;
        },

        dosageFormWrapper: {
            get() {
                return this.batchObj.dosageForm == null
                    ? null
                    : this.dosageFormsOptions.find(_ => _.id == this.batchObj.dosageForm);
            },

            set(value) {
                this.batchObj.dosageForm = value != null ? value.id : null;
            }
        },

        sortimentUploadTypes() {
            return ['default', 'ait2', 'apotronik']
        },

        acceptedFilesTotal() {

            let i = 0;

            this.files.accepted.forEach(a => {
                a.assets.forEach(asset => {
                    i++;
                })
            });
            return i;

        },

        acceptedFiles() {
            return this.files.accepted;
        },

        rejectedFiles() {
            return this.files.rejected;
        },

        apopointProductVisibility() {
            return this.$store.getters.getTermsByTaxonomy('APOPOINT_PRODUCT_VISIBILITY');
        },

        apopointVisibility() {
            return this.$store.getters.getTermsByTaxonomy('APOPOINT_VISIBILITY');
        },

        pharmacySelected() {
            return this.$store.getters.getPIMPharmacy;
        },

    },

    watch: {


    },

    created() {
        this.froalaConfig.key = this.$config.froalaKey;

    },

    mounted() {

        // this.showModalConfirmation = true;

    },

    methods: {

        onSelectRows(rows) {

            this.markedRows = rows.map(r => r.id);

        },

        onTableDataLoaded(val) {

            this.tableDataLoaded = val;

        },

        newProduct() {

            this.$router.push({ name: 'pimProductNew' })

        },

        setAssetActive(file, asset = null) {

            file.assets.forEach(a => a.isActive = false);
            file.isActive = false;

            if (asset != null) {
                asset.isActive = true;
            } else {
                file.isActive = true;
            }

            console.log(file);

        },

        normalizer(node) {

            return {
                id: node.id,
                label: node.name,
                children: node.children
            }

        },

        getImagePath(asset, thumb = false) {

            return this.$config.assets + asset.path + '/' + (thumb != false ? 'thumb/' : '') + asset.filename;

        },

        batchIt() {

            this.modal.isSaving = true;
            var self = this;

            if (this.uploadedFiles.length > 0 && Object.keys(this.batchObj).length == 0) {

                let files = {
                    ids: this.markedRows,
                    assets: this.uploadedFiles
                }

                this.axios.post(this.$config.api + 'pimProduct/assignAssets', files)
                    .then(res => {
                        this.$notify.success({ content: this.$t('PIM-BATCH-SUCCESS') })
                        this.closeModal(true);
                    })

            }

            else if (this.uploadedFiles.length == 0 && Object.keys(this.batchObj).length > 0) {

                let saveData = [];

                this.markedRows.forEach(row => {
                    saveData.push({ ...this.batchObj, ...{ id: row } });
                })

                this.axios.put(this.$config.api + 'pimProduct', saveData)
                    .then(res => {
                        this.$notify.success({ content: this.$t('PIM-BATCH-SUCCESS') })
                        this.closeModal(true);
                    })
            }

            else if (this.uploadedFiles.length > 0 && Object.keys(this.batchObj).length > 0) {

                let files = {
                    ids: this.markedRows,
                    assets: this.uploadedFiles
                }
                let saveData = [];

                this.markedRows.forEach(row => {
                    saveData.push({ ...this.batchObj, ...{ id: row } });
                })

                this.axios.post(this.$config.api + 'pimProduct/assignAssets', files)
                    .then(res => {
                        return this.axios.put(this.$config.api + 'pimProduct', saveData);
                    })
                    .then(res => {
                        this.modal.isSaving = false;
                        this.$notify.success({ content: this.$t('PIM-BATCH-SUCCESS') })
                        this.closeModal(true);
                    })

            }
        },

        uploadMultiFilesConfirmation() {

            this.showModalConfirmation = true;

        },

        /*
        uploadMultiFiles(replace = false) {

            this.multiUploadReplaceFiles = replace;

            this.modal.isSaving = true;
            this.uploadProcedere = 1;
            this.showModalConfirmation = false;

            // if we came here from the "ZIP Uploading"
            if (this.isZipUploading) {

                this.acceptedFiles.forEach((a) => {

                    a.assets.forEach((asset, index) => {

                        this.uploadedFiles.push({
                            product_id: a.id,
                            // asset_id: a.asset_id,
                            asset_id: Number(a.assets_ids[index]),
                            isDefault: asset.isActive
                        })

                    })

                })

                // console.log("replace? ", this.multiUploadReplaceFiles);
                // console.log("uploadedFiles: ", this.uploadedFiles);


                this.axios.post(this.$config.api + 'pimProduct/assignAssets', { isZipUploading: true, replace: this.multiUploadReplaceFiles, assignments: this.uploadedFiles })
                    .then(res => {

                        this.modal.isSaving = false;
                        this.uploadProcedere = 5;
                        this.modal.class = "fin";

                        // remove all files from dropzone
                        this.$refs.vueDropzonePimMulti.$children[0].removeAllFiles();

                    })

                // common usage, normal multi files uploading, proceed with the vue-dropzone queue
            } else {

                this.$refs.vueDropzonePimMulti.$children[0].processQueue();

            }

        },
        */

        async uploadMultiFiles() {

            // this.multiUploadReplaceFiles = replace;

            this.modal.isSaving = true;
            this.uploadProcedere = 1;
            this.showModalConfirmation = false;

            // if we came here from the "ZIP Uploading"
            if (this.isZipUploading) {

                this.acceptedFiles.forEach((a) => {

                    a.assets.forEach((asset, index) => {

                        this.uploadedFiles.push({
                            product_id: a.id,
                            asset_id: Number(a.assets_ids[index]),
                            isDefault: asset.isActive
                        })

                    })

                })

                // console.log("replace? ", this.multiUploadReplaceFiles);
                // console.log("uploadedFiles: ", this.uploadedFiles);


                try {
                    const res = await this.axios.post(this.$config.api + 'pimProduct/assignAssets', {
                        isZipUploading: true,
                        mode: this.fileUploadBehaviourType,
                        assignments: this.uploadedFiles
                    });

                    if (typeof res !== 'undefined') {
                        const batchId = res.data.batchId;
                        if( typeof batchId !== 'undefined' && batchId !== null) {
                            await this.checkBatchStatus(batchId);
                        }
                    }
                } catch (err) {
                    console.log(err);
                    this.modal.isSaving = false;
                }

                // common usage, normal multi files uploading, proceed with the vue-dropzone queue
            } else {

                this.$refs.vueDropzonePimMulti.$children[0].processQueue();

            }

        },

        async checkBatchStatus(batchId) {
            const self = this;
            const intervalId = setInterval(async () => {
                try {
                    const res = await self.axios.post(self.$config.api + 'pimProduct/assignAssets', { batchId: batchId });
                    self.progressStatus = res.data;
                    self.modal.class = "fin";
                    self.uploadProcedere = 4;

                    // Terminate if progress is 1 (as requested by user)
                    if (res.data && (res.data.progress === 1 || res.data.progress === "1")) {
                        clearInterval(intervalId);
                        self.uploadProcedere = 5;
                        self.modal.class = "fin";
                        self.modal.isSaving = false;

                        // remove all files from dropzone
                        if (self.$refs.vueDropzonePimMulti && self.$refs.vueDropzonePimMulti.$children[0]) {
                            self.$refs.vueDropzonePimMulti.$children[0].removeAllFiles();
                        }
                    }
                } catch (e) {
                    console.error("Batch status check failed:", e);
                    clearInterval(intervalId);
                    self.modal.isSaving = false;
                }
            }, 1000);

        },

        dzFilesAddedMulti(file) {

            this.uploadProcedere = 1;
            var self = this;

            setTimeout(() => self.dzFilesAddedMultiReal(file), 1500);

        },

        dzCompleteZip(response) {

        },

        dzSuccessZip(file, response) {

            var result = JSON.parse(file.xhr.response);
            this.zipUploadingFolder = result.folder;

            // let assetPath = 'https://datenbank.apothekenkatalog.at/herba/data/temp/extracted';
            let assetPath = this.$config.cdnHost + 'herba/data/temp/extracted';


            // dam/product/3907568/pimProductBatchZip_d5d774372e4e590b6a4c8fdf4e473680.png

            // handle accepted files
            for (let extRef in response.accepted) {

                response.accepted[extRef].isActive = false;

                // extract the image name
                var parts = response.accepted[extRef].image.split("/");
                var imgName = parts[parts.length - 1]; // Or parts.pop();

                response.accepted[extRef].image = assetPath + response.accepted[extRef].image;
                response.accepted[extRef].special = true;

                // loop through file assets
                for (let i = 0; i < response.accepted[extRef].assets.length; i++) {

                    let assetUrl = assetPath + response.accepted[extRef].assets[i];

                    response.accepted[extRef].assets[i] = {
                        isActive: i == 0,
                        url: assetUrl,
                        name: imgName,
                        type: 'image/png',
                    }

                }

                this.files.accepted.push(
                    response.accepted[extRef]
                )

            }

            // handle rejected files
            response.rejected.forEach(r => {

                // extract the image name
                var parts = r.split("/");
                var imgName = parts[parts.length - 1]; // Or parts.pop();

                this.files.rejected.push({
                    isActive: false,
                    url: assetPath + r,
                    name: imgName,
                    type: 'image/png',
                })

            })

            this.isZipUploading = true;

            // if there are more than 50 pictures to be uploaded and at least one is a "valid" image,
            // we skip the selection process
            if ((response.accepted.length + response.rejected.length) > 50 && this.acceptedFiles.length > 0) {

                // this.multiUploadReplaceFiles = true;
                this.fileUploadBehaviourType = "REPLACE";
                this.modal.isSaving = true;

                console.log("-----------------------------");
                this.$refs.vueDropzonePimMulti.$children[0].processQueue();
                console.log("-----------------------------");

            } else {

                this.modal.class = "multi";
                this.modal.title = this.$t('PIM-MODAL-TITLE-MULTI_IMAGE_UPLOAD');
                this.modal.type = 'multi-upload-files';

                this.uploadProcedere = 2;

            }


        },


        dzFilesAddedZip(file) {


        },


        dzFilesAddedMultiReal(file) {

            var assetsToTest = [];

            for (var k in file) {
                if (file.hasOwnProperty(k)) {
                    assetsToTest.push(file[k].name);
                }
            }

            this.axios.post(this.$config.api + 'pimProduct/assignAssets', { test: '1', assets: assetsToTest })
                .then(res => {

                    // handle accepted files
                    for (let extRef in res.data.accepted) {

                        res.data.accepted[extRef].isActive = false;

                        // loop through file assets
                        for (let i = 0; i < res.data.accepted[extRef].assets.length; i++) {

                            // find matching uploaded images
                            for (let k = 0; k < file.length; k++) {

                                file[k].accepted = true;

                                if (res.data.accepted[extRef].assets[i] == file[k].name) {

                                    res.data.accepted[extRef].assets[i] = {

                                        isActive: i == 0,
                                        url: file[k].dataURL,
                                        type: file[k].type,
                                        fileName: file[k].name,
                                    }

                                }

                            }


                        }

                        this.files.accepted.push(
                            res.data.accepted[extRef]
                        )

                    }


                    // handle rejected files
                    res.data.rejected.forEach(r => {

                        for (let i = 0; i < file.length; i++) {

                            if (r == file[i].name) {

                                file[i].accepted = false;

                                this.files.rejected.push({
                                    isActive: false,
                                    url: file[i].dataURL,
                                    name: file[i].name,
                                    type: file[i].type
                                });

                                this.$refs.vueDropzonePimMulti.$children[0].removeFile(file[i]);

                            }


                        }

                    })

                    // if there are more than 50 pictures to be uploaded and at least one is a "valid" image,
                    // we skip the selection process
                    if (file.length > 50 && this.acceptedFiles.length > 0) {

                        this.multiUploadReplaceFiles = true;
                        this.modal.isSaving = true;
                        this.$refs.vueDropzonePimMulti.$children[0].processQueue();

                    } else {

                        this.uploadProcedere = 2;

                    }

                })

        },

        dzSuccess(file) {

            var result = JSON.parse(file.xhr.response);

            this.uploadedFiles.push({
                path: result.dir,
                filename: result.fileName,
                isActive: false
            });

            // remove all files from dropzone first
            // this.$refs['vueDropzonePimBatch'].$children[0].removeAllFiles();

        },

        dzSuccessMulti(file) {

            var self = this;

            for (let i = 0; i < file.length; i++) {

                let res = JSON.parse(file[i].xhr.response);

                self.acceptedFiles.forEach(a => {

                    a.assets.forEach(asset => {

                        if (asset.fileName == res[i].uploadFilename) {

                            self.uploadedFiles.push({
                                product_id: a.id,
                                asset_id: res[i].id,
                                isDefault: asset.isActive
                            })

                        }

                    })


                })

            }


            if (this.$refs.vueDropzonePimMulti.$children[0].getQueuedFiles().length == 0) {

                this.axios.post(this.$config.api + 'pimProduct/assignAssets', { replace: self.multiUploadReplaceFiles, assignments: self.uploadedFiles })
                    .then(res => {

                        self.modal.isSaving = false;
                        self.uploadProcedere = 5;
                        self.modal.class = "fin";

                        // remove all files from dropzone
                        self.$refs.vueDropzonePimMulti.$children[0].removeAllFiles();

                    })

            }

        },

        uploadSortimentData() {

            this.modal.isLoading = false;
            this.modal.isSaving = false;
            this.modal.class = "sortimentsUpload";
            this.modal.type = "sortimentUpload";
            this.modal.title = "Upload Sortimentsdatei";

            this.showModal = true;

        },


        dzSuccessSortiment(file, response) {

            var self = this;
            this.modal.isLoading = false;
            this.modal.isSaving = false;
            this.modal.type = "sortimentUploadProgress";

            this.showModal = true;

            this.$refs.vueDropzone.$children[0].removeAllFiles();
            let taskLogId = response.taskLogId;

            self.refreshIntervalId = setInterval(function () {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                    .then(response => {

                        self.progressStatus = response.data;

                        if (['Finished', 'Error'].indexOf(response.data.status) > -1) {

                            clearInterval(self.refreshIntervalId);

                            // this.$refs.pimTable.refresh();
                            this.$refs.pimProducts.$refs.pimTable.refresh();

                            /*
                            this.init().then(res => {
                                console.log("res: ", res);
                                self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                self.closeModal();

                            })
                            */


                            /*
                            self.axios.get(self.$config.api + 'newsletter/subscribers?site='+self.siteId)
                                .then(function(response) {
                                    self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                    self.recipients.data = response.data;
                                    self.closeModal();
                                })
                            */

                        }

                    });

            }.bind(self), 1000);

        },

        /*
        toggleMarkAll() {

            this.markedRows = this.allMarked ? [] : this.$refs.pimTable.tableData.map(row => row.id);
            this.allMarked = !this.allMarked;

        },
        */

        async productsBatch() {

            this.showModal = true;
            this.modal.title = this.$t('PIM-MODAL-TITLE-PRODUCTS_BATCH');
            this.modal.class = 'products-batch';
            this.modal.type = 'products-batch';
            this.batchObj = {
                packagingSizes: {},
                erp: {}
            };

            if (this.dosageForms == null) {
                let dosageFormsRes = await this.axios.get(this.$config.api + "pimProduct/dosageForms");
                this.dosageForms = dosageFormsRes.data;
            }

            if (this.categories == null) {

                this.modal.isLoading = true;
                this.loadCategories().then(res => {
                    this.modal.isLoading = false;
                    this.categories = res.data;
                });

            }

        },

        makeVariable() {

            var self = this;

            var makeVariable = function () {

                self.axios.post(self.$config.api + 'pimProduct/group', { ids: self.markedRows }).then(res => {
                    self.$notify.success({ content: 'PIM-PRODUCTS-SUCCESSFULLY_GROUPED' });
                    self.markedRows = [];
                })

            }

            var self = this;
            this.$modal.confirm({
                title: self.$t('PIM-PRODUCTS-MAKE_VARIABLE-TITLE'),
                content: self.$t('PIM-PRODUCTS-MAKE_VARIABLE-TEXT'),
                onOk: function () {
                    makeVariable();
                },
                okText: self.$t('PIM-PRODUCTS-MAKE_VARIABLE-OK'),
                cancelText: self.$t('PIM-PRODUCTS-MAKE_VARIABLE-CANCEL')
            });

        },

        massImageUpload() {

            this.showModal = true;
            this.modal.class = "multi";
            this.modal.title = this.$t('PIM-MODAL-TITLE-MULTI_IMAGE_UPLOAD');
            this.modal.type = 'multi-upload-files';

        },

        zipFileUpload() {

            this.showModal = true;
            this.modal.class = "";
            this.modal.title = this.$t('PIM-MODAL-TITLE-MULTI_ZIP_UPLOAD');
            this.modal.type = 'upload-zip';

        },

        openUploadModal() {

            this.showModal = true;
            this.modal.class = "";
            this.modal.title = this.$t('PIM-MODAL-TITLE-SELECT_UPLOAD_TYPE');
            this.modal.type = 'upload-switcher';

        },

        loadCategories() {

            var self = this;

            return new Promise(function (resolve, reject) {

                let url = self.$config.api + 'pimCategory/tree' + (self.pharmacySelected != null && self.pharmacySelected.id ? '?site=' + self.pharmacySelected.id : '');
                // let url = self.$config.api + 'pimCategory/tree';

                self.axios.get(url)
                    .then(res => {
                        resolve(res);
                    })

            });

        },


        async closeModal(refresh = false) {

            /*
            // if we it was zipUploading, then send a request to the server, so the server is informed to clear the database from already uploaded files
            if(this.isZipUploading == true && this.zipUploadingFolder != null) {
              console.log("uploadFolder: ", this.zipUploadingFolder);
              await this.axios.post(this.$config.api + 'pimProduct/clearTemp?folder='+this.zipUploadingFolder);
            }
            */


            if (refresh === true) {

                // https://github.com/matfish2/vue-tables-2/issues/174
                // this.$refs.pimTable.refresh();
                // this.$refs.pimTable.getData();
                this.$refs.pimProducts.$refs.pimTable.getData()
                // this.$refs.pimProducts.toggleMarkAll();
                // this.allMarked = false;
                // this.markedRows = [];

            }
            this.$refs.pimProducts.allMarked = false;
            this.$refs.pimProducts.markedRows = [];

            this.files = {
                all: [],
                accepted: [],
                rejected: []
            }

            if (typeof this.$refs.vueDropzonePimMulti != 'undefined') {
                this.$refs.vueDropzonePimMulti.$children[0].removeAllFiles();
            }
            this.modal.isSaving = false;
            this.modal.isLoading = false
            this.modal.class = "";
            this.uploadProcedere = 0;
            this.uploadedFiles = [];
            this.showModal = false;
            this.isZipUploading = false;
            this.zipUploadingFolder = null;

            this.sortimentUploadType = 'default';

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);



            this.progressStatus = null;

        },

    }

}
</script>


<style lang="scss" scoped>
@import '~../../assets/css/variables.scss';
@import '~pretty-checkbox/src/pretty-checkbox.scss';

.uploadBehaviourTypeSelection {

    flex-wrap: wrap;
    margin-top: 24px;

    .radio {
        display: block;
        padding-bottom: 12px;
        padding-left: 28px;
    }
}

.p-default {
    margin: 0;
}

.pimTable {

    .imgWrapper {
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: contain;
        width: 80px;
        height: 60px;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }

    .imgWrapper[lazy=loading] {
        background-size: 30% !important;
    }

    .imgWrapper[lazy=error] {
        background-image: none !important;
    }

}

.rejectedFiles {

    .filesContainer {

        .fileBox {

            width: auto;
            min-width: auto;
            max-width: 80px;
            overflow: hidden;

            .name {
                white-space: nowrap;
            }

            .imgWrapper {
                min-width: 65px;
                max-width: 65px;
                height: 50px;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;

            }
        }
    }

}

.filesContainer {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 25px 0;

    .fileBox {
        min-width: 120px;
        /*
            width: calc( 100% / 6.31);
            max-width: calc( 100% / 6.31);
            */
        background: #f1f1f1;
        border: 1px solid #ddd;
        border-radius: 2px;
        padding: 5px;
        font-size: 10px;
        margin: 0 8px 8px 0;

        .name {
            height: 30px;
            max-width: 160px;
        }

        .images {

            display: flex;
            justify-content: center;
            margin: 5px 0 0 0;

            .image {

                flex: 1;
                background: #d5d5d5;
                border-radius: 2px;
                font-size: 8px;
                text-transform: uppercase;
                padding: 4px;
                cursor: pointer;
                border: 1px solid transparent;
                transition: all .2s ease;
                width: 80px;
                max-width: 80px;

                &:not(:last-child) {
                    margin-right: 5px;
                }

                &.is-active {
                    background-color: $themeColor1;
                }

                &:hover {
                    border-color: $themeColor1;
                }

                &.is-disabled {
                    pointer-events: none;
                    background: none;
                    border: none;

                    .imgWrapper {
                        background-color: transparent;
                    }

                    &:hover {
                        border: none;
                    }

                }

                .imgWrapper {
                    flex: 1;
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: contain;
                    border: none;
                    width: auto;
                    max-width: 65px;
                    height: 50px;
                    margin-top: 1px;
                }
            }

        }
    }

}


.sortimentTypeButtons {
    margin: 0 0 15px 0;

    display: flex;
    justify-content: space-between;

    >div {
        background-color: #f1f1f1;
        transition: all .3s ease;
        cursor: pointer;
        padding: 12px 25px;
        text-align: center;
        border-radius: 2px;
        max-width: 32.5%;
        flex: 1;

        &:hover {
            background-color: #DDD;
        }

        &.is-active {
            background-color: $themeColor1;
        }
    }
}

.sortimentTypeHint {
    font-size: 12px;
    margin-bottom: 25px;

    strong {
        font-weight: 600;
        text-transform: uppercase;
        display: inline-block;
        margin-right: 3px;
    }
}
</style>

<style lang="scss" scoped>

    .modal {
        &.products-batch {
            ::v-deep .modal-card {
                
                max-height: 100% !important;

                max-height: 100% !important;
                
                .modal-card-body {
                    padding: 0;
                    overflow: hidden;
                    overflow-y: auto !important;
                    /*max-height: 200px;*/

                    .tabs {
                        .tab-list {
                            padding-top: 12px;
                        }
                        .tab-content {
                            margin-bottom: 0 !important;
                            padding: 20px;

                            .tab-pane {
                                padding: 0 !important;
                            }
                        }
                    }
                }
            }
        }
    }

</style>
<style scoped>
.modal.modalConfirmation {}

.modal.modalConfirmation>>>.close {
    display: none;
}

.modal.sortimentsUpload>>>.modal-card {
    min-height: 50px;
}

.modal.multi>>>.modal-card {
    width: 1024px;
    min-height: 85vh !important;
    max-height: 85vh !important;
}

.modal.multi>>>.modal-card-body {
    overflow: auto;
    overflow-y: visible;
}

.modal.multi>>>.modal-card .modal-card-body .tab-content {
    margin-bottom: 0 !important;
}

.modal.multi>>>.modal-card .modal-card-body {
    position: relative;
}

.modal.multi>>>.modal-card .modal-card-body .vue-dropzone {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 20px;
    width: auto !important;
    height: auto !important;
}

.modal.fin>>>.modal-card {
    width: 520px;
    min-height: 100px;
    max-height: auto;
}

>>>.checkboxWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding-left: 4px;
}

.inputName {
    margin: 0;
    padding: 0;
    height: auto;
    line-height: inherit;
    font-size: 12px;
    background: none;
    border: 0;
    transition: all .3s ease;
    cursor: pointer;
}

.inputName:not(:focus) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inputName:focus {
    padding: 8px;
    background: #eaeaea;
}


>>>.pimTable .VueTables__search {
    display: none;
}

>>>.pimTable .VueTables__table {
    position: relative !important;
}

>>>.pimTable .VueTables__table td {
    position: relative !important;
}

.overlay-loader {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    opacity: 0.8;
}

>>>.pimTable .v-spinner {
    position: absolute !important;
    z-index: 999;
    top: 0 !important;
    bottom: 0;
    height: 100% !important;
    width: 100vw;
}

>>>.pimTable .VueTables__table td:first-child {
    width: 20px;
    max-width: 20px;
}

>>>.pimTable .VueTables__table td.thumbnail {
    width: 100px;
    max-width: 100px;
}

>>>.pimTable .VueTables__table td.pzn {
    width: 100px;
    max-width: 100px;
}

>>>.pimTable .VueTables__table td.packagingSize {
    width: 120px;
    max-width: 120px;
}

>>>.pimTable .VueTables__table td.price {
    width: 100px;
    max-width: 100px;
}

>>>.pimTable .VueTables__table td.variable,
>>>.pimTable .VueTables__table th.variable {
    width: 50px;
    max-width: 50px;
    text-align: center;
}

>>>.pimTable .VueTables__table td.del,
>>>.pimTable .VueTables__table th.del {
    width: 50px;
    max-width: 50px;
    text-align: center;
}

.loadingOverlay {
    position: absolute;
    z-index: 99;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #FFF;
    background: rgba(255, 255, 255, .5);
    display: flex;
    justify-content: center;
    align-items: center;
}


>>>.v-spinner.small {
    height: auto !important;
    max-width: 250px;
    margin: 0;
}

>>>.v-spinner.small .v-clip {
    height: 12px !important;
    width: 12px !important;
}

>>>.customWarning {
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent !important;
    color: #666 !important;
}

>>>.customWarning .wrap-icon {
    margin-top: -9px;
}

>>>.customWarning .wrap-icon i {
    font-size: 16px;
    color: #666;
}
</style>

<style lang="scss" scoped>
.products-batch {
    ::v-deep .modal-card {
        width: 640px;
    }
}

.froalaRTE {
    ::v-deep .fr-view {
        word-wrap: normal;
        white-space: normal;

        ul {
            display: block;
            border: none;
            margin-bottom: 15px;
            list-style-type: disc;
            list-style-position: outside;

            li {
                display: list-item;
            }
        }

        h1,
        h2,
        h3,
        h4 {
            all: revert;
        }
    }
}
</style>
